import { upload } from '@/api/common'

/**
 * TT 送审资料替换文件上传，返回后端 fileId（用于 resubmit 请求参数）
 */
export function uploadReviewMaterialFile(file) {
  if (!file) {
    return Promise.reject(new Error('未选择文件'))
  }
  const formData = new FormData()
  formData.append('file', file)
  return upload(formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => {
    const data = (res && res.data) || {}
    const fileId = data.fileId
    const fileUrl = data.fileUrl || data.url || ''
    if (!fileId) {
      return Promise.reject(new Error('上传成功但未返回 fileId'))
    }
    return { fileId: Number(fileId), fileUrl }
  })
}
